import { PureComponent } from "react";
import { connect } from "react-redux";

interface IBubbleItem {
    id: string;
    bubbleProps: any;
    customComponent: any;
}

interface IBubbleContainer {
    bubblesNotificationList: [IBubbleItem];
}

class BubbleNotificationContainer extends PureComponent<IBubbleContainer, any> {
    constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div>
                {this.props.bubblesNotificationList
                    ? this.props.bubblesNotificationList.map((bubble) => {
                          const Bubble = bubble.customComponent;
                          return (
                              <Bubble
                                  key={bubble.id}
                                  {...bubble.bubbleProps}
                              />
                          );
                      })
                    : null}
            </div>
        );
    }
}

function mapStateToProps({ common }) {
    const bubblesNotificationList = common.bubblesNotificationList;
    return {
        bubblesNotificationList,
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}
const connected = connect(mapStateToProps, mapDispatchToProps)(BubbleNotificationContainer);
export default connected;
